import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[focus]'
})
export class InputFocusDirective implements AfterViewInit {
  @Input() focus: boolean;

  constructor(private element: ElementRef) {}

  ngAfterViewInit() {
    if (this.focus) {
      this.element.nativeElement.focus();
    }
  }
}
